var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { namespace } from "vuex-class";
import { Emit, Watch } from 'vue-property-decorator';
import DataBox from "~/components/common/data-box.vue";
import { SmartCollectionService } from "~/services/domain-service/smart-collection.service";
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service';
var MessageCollectionModule = namespace('message-collection');
var MessageContactList = /** @class */ (function (_super) {
    __extends(MessageContactList, _super);
    function MessageContactList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        return _this;
    }
    MessageContactList.prototype.refreshData = function () {
        var _this = this;
        var request = {
            caseIdList: this.caseIdList,
            relationshipSet: this.checkRelation,
        };
        this.smartCollectionService.getPersonalContacts(request).subscribe(function (data) { return _this.dataSet = data || []; });
    };
    MessageContactList.prototype.onChange = function (val) { };
    MessageContactList.prototype.watchDataSet = function (val) {
        this.onChange(val);
    };
    /**
     * 添加手机号
     */
    MessageContactList.prototype.addContact = function (data) {
        var _this = this;
        this.contactData = data;
        this.$prompt('请输入手机号码', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: this.$validator.regex.phoneNumber,
            inputErrorMessage: '手机号码格式不正确'
        }).then(function (_a) {
            var value = _a.value;
            var request = {
                caseId: data.caseId,
                contName: data.contName,
                dataSource: 'REPAIR',
                phone: value,
                phoneType: 'MOBILE',
                relation: data.relation
            };
            _this.caseOperatorPageService.addPersonalContact(request).subscribe(function (data) {
                _this.refreshData();
                _this.$message.success('添加成功');
            });
        }).catch(function () {
            _this.$message.info('取消输入');
        });
    };
    /**
     * 移除联系人
     */
    MessageContactList.prototype.removeContact = function (scope) {
        var index = scope.$index;
        this.dataSet.splice(index, 1);
    };
    /**
     * 合并行
     */
    MessageContactList.prototype.spanMethod = function (_a) {
        var row = _a.row, column = _a.column, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
        var columnProperty = 'caseNumber';
        if (column.property !== columnProperty)
            return;
        // 当前单元格的值
        var currentValue = row[columnProperty];
        var span = {
            rowspan: 0,
            colspan: 0
        };
        var beforRow = rowIndex > 0 ? this.dataSet[rowIndex - 1] : null;
        if (beforRow && beforRow[columnProperty] === currentValue)
            return span;
        // 如果当前单元格的值与上一行的对应单元格的值一致，则合并行已经计算过
        span.colspan = 1;
        span.rowspan = 1;
        var nextRowIndex = rowIndex + 1;
        while (nextRowIndex < this.dataSet.length) {
            // 如果下一行对应单元格的值与当前单元格的值一致
            var nextRowValue = this.dataSet[nextRowIndex][columnProperty];
            if (nextRowValue === currentValue)
                span.rowspan += 1;
            nextRowIndex += 1;
        }
        return span;
    };
    __decorate([
        Dependencies(SmartCollectionService)
    ], MessageContactList.prototype, "smartCollectionService", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], MessageContactList.prototype, "caseOperatorPageService", void 0);
    __decorate([
        MessageCollectionModule.State
    ], MessageContactList.prototype, "checkRelation", void 0);
    __decorate([
        MessageCollectionModule.State
    ], MessageContactList.prototype, "caseIdList", void 0);
    __decorate([
        Emit('on-change')
    ], MessageContactList.prototype, "onChange", null);
    __decorate([
        Watch('dataSet')
    ], MessageContactList.prototype, "watchDataSet", null);
    MessageContactList = __decorate([
        Component({
            components: {
                DataBox: DataBox
            }
        })
    ], MessageContactList);
    return MessageContactList;
}(Vue));
export default MessageContactList;
